import { defaultTo } from 'ramda';
import type { IPromotionTypeInfo } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PromotionTypeInfo';
import type { IPublishTerm } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';
import { IPromotionService } from '../../../../reducers/v2';
import { mapPromotionType } from './mapPromotionType';
import { EUnavailableReason } from '../../../../types/reducers/publishTerms';
import { ITariffIdentificator } from '../../../../reducers/v2/publicationPackages/types';

export function mapPromotionService(service: IPromotionTypeInfo, terms: IPublishTerm[]): IPromotionService {
  const serviceType = terms.find(term => term.promotionType === service.promotionType);

  return {
    type: mapPromotionType(service.promotionType),
    selected: service.isSelected,
    price: service.price,
    token: service.token,
    disabled: service.isDisabled,
    isRecommended: service.isRecommended,
    unavailableReasonType: service.unavailableReasonType as unknown as EUnavailableReason,
    tariffIdentificator: serviceType!.periods![0].tariffIdentificator as unknown as ITariffIdentificator,
    diffPriceId: defaultTo(0, service.diffPriceId),
    diffPriceIterationId: defaultTo('', service.diffPriceIterationId),
    diffPriceGranuleGuid: defaultTo('', service.diffPriceGranuleGuid),
  };
}
